var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gdi-container"},[_c('p',{staticClass:"text-2xl mb-6"},[_vm._v("Statistiques d'utilsation")]),_c('filters',{attrs:{"progress":_vm.progress}}),_c('g-d-usage-stats-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }